export default {
  setRTL: issue => {
    global.isRTL = issue.isRtl;
  },
  getRTL: () => {
    return global.isRTL;
  }
};
